import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const user_change_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M4.9175,6.5349 C3.0695,7.3759 2.5025,9.3629 2.5025,11.5039 L10.5035,11.5039 C10.5035,9.3539
          9.9265,7.3679 8.0855,6.5279 M15.9111,16.5222 C14.3051,17.4752 13.5021,19.5102 13.5021,21.5032
          L21.5041,21.5032 C21.5041,19.5002 20.6941,17.4712 19.0891,16.5222 M17.5,12.5002 C18.647,12.5002
          19.5,13.6622 19.5,15.0002 C19.5,15.5632 19.349,16.0952 19.089,16.5222 C18.73,17.1102 18.164,17.5002
          17.5,17.5002 C16.836,17.5002 16.27,17.1102 15.911,16.5222 C15.651,16.0952 15.5,15.5632 15.5,15.0002
          C15.5,13.6622 16.353,12.5002 17.5,12.5002 Z M4,16.1384 L6.5,13.6684 L9,16.1324 M20,7.8352
          L17.494,10.3062 L15,7.8412 M17.4941,10.3059 C17.8831,5.4119 15.3801,2.5039 11.9921,2.5148689
          M6.5,2.5002 C7.647,2.5002 8.5,3.6622 8.5,5.0002 C8.5,5.4782 8.392,5.9332 8.2,6.3212 C7.854,7.0202
          7.238,7.5002 6.5,7.5002 C5.763,7.5002 5.146,7.0212 4.8,6.3232 C4.607,5.9352 4.5,5.4792 4.5,5.0002
          C4.5,3.6622 5.353,2.5002 6.5,2.5002 Z M6.5,13.6687 C6.112,18.5627 8.614,21.5137 12.002,21.5017365"
      />
    </svg>
  );
};
